<template src="./no-recommendation.html"></template>

<script>
export default {
  name: 'GondolaMiniNoRecommendation',
};
</script>
